import { useState, useEffect } from "react";
import TopUsersMini from "./TopUsersMini";
import FollowInsta from "./FollowInsta";

const FACE =
    "absolute inset-0 rounded-[3vh] bg-white shadow-[0_0.5vh_2vh_rgba(18,22,31,0.08)] overflow-hidden";

function TopSocialFlipCard() {
    const [flipped, setFlipped] = useState(false);

    useEffect(() => {
        const timer = setInterval(() => setFlipped((f) => !f), 30000);
        return () => clearInterval(timer);
    }, []);

    return (
        <div
            className="w-full h-full cursor-pointer"
            style={{ perspective: "200vh" }}
            onClick={() => setFlipped((f) => !f)}
        >
            <div
                className="relative w-full h-full transition-transform duration-700"
                style={{
                    transformStyle: "preserve-3d",
                    transform: flipped ? "rotateY(180deg)" : "rotateY(0deg)",
                }}
            >
                <div className={FACE} style={{ backfaceVisibility: "hidden" }}>
                    <TopUsersMini />
                </div>
                <div
                    className={FACE}
                    style={{
                        backfaceVisibility: "hidden",
                        transform: "rotateY(180deg)",
                    }}
                >
                    <FollowInsta />
                </div>
            </div>
        </div>
    );
}

export default TopSocialFlipCard;
